export const LicenseRecipe = {
    $type$: 'Recipe',
    name: 'License',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'description',
            itemtype: { type: 'string' }
        }
    ]
};
export const LicenseReverseMap = ['License', new Set(['*'])];
//# sourceMappingURL=License.js.map